//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from "@/components/Footer.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "App",
  components: { Footer },
  data() {
    return {
      active: null,
      lastScrollPosition: 0,
      headerclass: "",

      dialog: false,
      banner: {}

    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.getCurrentUser();

    this.$http.get("/banner",{})
    .then(result=>{
      this.banner = result.data
      if(this.banner.show_banner == 'Y' && this.$route.name == 'Home'){
        this.banner.show_banner = true
      }
      else{
        this.banner.show_banner = false
      }
    })
  },
  computed: mapState(["currentUser"]),

  methods: {
    ...mapActions(["getCurrentUser"]),
    logout() {
      localStorage.removeItem("token-ppidbig");
      this.getCurrentUser();
      this.$router.push("/user/login");
    },
    clickMenu(val) {
      this.active = val;

      this.$router.push("/" + val).catch(() => {});
        
      if (val != "") this.headerclass = "-transparent";
    },
    onScroll() {
      if (window.pageYOffset < 30) {
        this.headerclass = "";
      } else {
        this.headerclass = "-transparent";
      }
    },
    goTo(link){
      this.$router.push(link).catch(()=>{})
    },
    goToPDF(){
      window.open(this.banner.link, "_blank")
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
